function reactOpenPopupInfo(typeOf) {
    switch(typeOf) {
       // TA Popup
       case "IMG Academy Camp":
       var tempContent = `<div class="weeklySportCampsModal">
                           <h2>Weekly Sport Camps</h2>

                           <div class="descriptionHolder">
                               <div class="contentHolder">
                               <h3>For Ages 8 - 18*</h3>
                               <p>IMG Academy weekly sport camps give athletes the platform to maximize potential and elevate performance.</p>
                               <p><em>*Age eligibility differs by sport — see each sport page for details.</em></p>
                               <h3>Highlights</h3>
                               <ul>
                                   <li>Custom programming for your age, skill level, and goals</li>
                                   <li>Camps offered year-round to fit your school or sport schedule</li>
                                   <li>Elite sport instruction and core performance training</li>
                                   <li>Two sport-specific training sessions daily (AM/PM)</li>
                                   <li>Three strength & conditioning sessions per week</li>
                                   <li>Coach’s training evaluation</li>
                                   <li>Bed sheets, laundry service, and toiletry kit (boarding campers)</li>
                                   <li>Daily meals and hydration</li>
                                   <li>Under Armour gear kit</li>
                                   <li>IMG Academy+ Essentials membership</li>
                               </ul>
                               <div class="embed-responsive embed-responsive-16by9">
                                   <iframe class="embed-responsive-item" width="560" height="315" src="https://player.vimeo.com/video/1008949944" title="The Bedford Family" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                               </div>
                               </div>
                           </div>
                           </div>`;
         var overlayOptions = {
             btnOpen: null,
             containerClassOverride: 'fullscreen-overlay camp-popups twentySixSCPgeneral learnMorePopup',
             overlayType: 'popup',
             type: 'html',
             content: tempContent
         };
         var overlay = new ContentOverlay2(overlayOptions);
         overlay.open();
       break;
       case "Total Athlete Training Upgrade":
         var tempContent = `<div class="specializationsModal">
             <h2>Performance Training Sessions</h2>
             <p class="subhead">*Subject to availability when booking</p>
             <h3>For Ages 11-18*</h3>
             <p>Athletes choose a unique area of focus below per week of camp. Multi-week campers can take advantage of changing their session week-by-week for an enhanced training experience.</p>
             <p><em>*Age eligibility differs by sport — see each sport page for details.</em></p>
             <h3>Available Sessions</h3>

             <div class="specializations-modal">
                 <div class="card">
                     <div class="left">
                         <h4 class="strength">Strength &amp; power</h4>
                         <p>Campers focus on strength in core areas of explosive resistance, jumping and plyometrics, efficient power development, and learn correct motor patterns.</p>
                         <p><strong>Available during spring, summer, fall and holiday seasons.</strong></p>
                     </div>
                     <div class="right">
                         <div class="embed-responsive embed-responsive-16by9">
                             <iframe loading="lazy" class="embed-responsive-item" title="Strength &amp; Power Training Specialization" width="560" height="315" src="https://player.vimeo.com/video/1008181416?h=4570e5b34e&amp;origin=https:%2F%2Fwww.imgacademy.com" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" data-ready="true"></iframe>
                         </div>
                     </div>
                 </div>
                 <div class="card">
                     <div class="left">
                         <h4 class="speed">Speed &amp; agility</h4>
                         <p>Coaches work with campers on perfecting techniques around linear acceleration, maximum velocity, lateral movement, and multi-directional movement and agility.</p>
                         <p><strong>Available during spring, summer, fall and holiday seasons.</strong></p>
                     </div>
                     <div class="right">
                         <div class="embed-responsive embed-responsive-16by9">
                             <iframe loading="lazy" class="embed-responsive-item" title="Speed and Agility Training Specialization" width="560" height="315" src="https://player.vimeo.com/video/1008182784?h=66f2799a50&amp;origin=https:%2F%2Fwww.imgacademy.com" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" data-ready="true"></iframe>
                         </div>
                     </div>
                 </div>
                 <div class="card">
                     <div class="left">
                         <h4 class="leadership">Leadership &amp; communication</h4>
                         <p>Athletes work with our coaches to build skills around team building, verbal and non-verbal communication, identity, developing relationships, all while inspiring and empowering yourself and others.</p>
                         <p><strong>Available during summer season only.</strong></p>
                     </div>
                     <div class="right">
                         <div class="embed-responsive embed-responsive-16by9">
                             <iframe loading="lazy" class="embed-responsive-item" title="Leadership and Communication Specialization" width="560" height="315" src="https://player.vimeo.com/video/1008180788?h=b151b50f43&amp;origin=https:%2F%2Fwww.imgacademy.com" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" data-ready="true"></iframe>
                         </div>
                     </div>
                 </div>
                 <div class="card">
                     <div class="left">
                         <h4 class="mental">Mental performance</h4>
                         <p>Our mental performance coaches help athletes with their self-talk, breathing, imagery, focus, emotional regulation, and goal setting.</p>
                         <p><strong>Available during spring, summer, fall and holiday seasons.</strong></p>
                     </div>
                     <div class="right">
                         <div class="embed-responsive embed-responsive-16by9">
                             <iframe loading="lazy" class="embed-responsive-item" title="Mental Performance Specialization" width="560" height="315" src="https://player.vimeo.com/video/1008184316?h=b56c53fc68&amp;origin=https:%2F%2Fwww.imgacademy.com" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" data-ready="true"></iframe>
                         </div>
                     </div>
                 </div>
                 <div class="card">
                     <div class="left">
                         <h4 class="mental">Recovery+</h4>
                         <p>Gain a deeper understanding of optimal recovery practices for your mind and body through proven tools and techniques.</p>
                         <p><strong>Available during summer season only.</strong></p>
                     </div>
                     <div class="right">
                         <div class="embed-responsive embed-responsive-16by9">
                             <iframe loading="lazy" class="embed-responsive-item" title="Recovery+ Specialization" width="560" height="315" src="https://player.vimeo.com/video/1008181818?h=6989e5cde3&amp;origin=https:%2F%2Fwww.imgacademy.com" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" data-ready="true"></iframe>
                         </div>
                     </div>
                 </div>
                 <div class="card">
                    <div class="left">
                        <h4 class="mental">Build Your Brand</h4>
                        <p>Developed by Olympic Gold Medalist Richard Thompson and Dr. Peter Paciorek, while being led by IMG Academy experts, this program equips athletes with tools that extend far beyond sport.</p>
                        <p><strong>Available during summer season only.</strong></p>
                    </div>
                    <div class="right">
                        <div class="embed-responsive embed-responsive-16by9">
                            <img loading="lazy" class="embed-responsive-item" title="Build Your Brand" width="560" height="315" src="https://www.imgacademy.com/sites/default/files/build-your-brand-specialization.jpg">
                        </div>
                    </div>
                </div>
                 <div class="card">
                     <div class="left">
                         <h4 class="mental">Athlete Assessment &amp; Injury Prevention</h4>
                         <p>The on-campus sports physical therapists from Johns Hopkins All Children's Hospital will provide instruction and guidance on mobility, strength, neuromuscular control, and movement patterns within the framework of reducing risk of injury and improving athletic performance.</p>
                         <p><strong>Available during summer season only.</strong></p>
                     </div>
                     <div class="right">
                         <div class="embed-responsive embed-responsive-16by9">
                             <iframe loading="lazy" class="embed-responsive-item" title="Athlete Assessment & Injury Prevention Specialization" width="560" height="315" src="https://player.vimeo.com/video/1008184938?h=d0cea89cc6&amp;origin=https:%2F%2Fwww.imgacademy.com" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" data-ready="true"></iframe>
                         </div>
                     </div>
                 </div>
                 <div class="card">
                     <div class="left">
                         <h4 class="esl">English as a Second Language</h4>
                         <p>Campers will have a daily ESL course with weekly themes such as Inspiring People, Extreme Sports, the Endangered Planet, or Entrepreneurs. Instructors focus on communication skills, vocabulary development, conversation, short videos, and grammar as well as test preparation. For all options, please <a href="#" class="open-lead">contact an advisor</a>.</p>
                         <p><strong>Available during spring, summer, fall and holiday seasons.</strong></p>
                     </div>
                     <div class="right">
                         <div class="embed-responsive embed-responsive-16by9">
                             <iframe loading="lazy" class="embed-responsive-item" title="English as a Second Language Specialization" width="560" height="315" src="https://player.vimeo.com/video/1008182390?h=40825ae7c5&amp;origin=https:%2F%2Fwww.imgacademy.com" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" data-ready="true"></iframe>
                         </div>
                     </div>
                 </div>

             </div>

         </div>`;
         var overlayOptions = {
             btnOpen: null,
             containerClassOverride: 'fullscreen-overlay camp-popups twentySixSCPgeneral learnMorePopup',
             overlayType: 'popup',
             type: 'html',
             content: tempContent
         };
         var overlay = new ContentOverlay2(overlayOptions);
         overlay.open();
         break;
       case "Game Changer Training Upgrade":
       var tempContent = `<div class="gameChangerModal">
                        <h2>Ultimate Training Package</h2>
                        <p class="subhead">*Subject to availability when booking</p>

                        <div class="descriptionHolder">
                            <div class="contentHolder">
                            <h3>For Ages 11 - 18*</h3>
                            <p>Take your game to the next level with personalized training added to your camp experience.</p>
                            <p><em>*Age eligibility differs by sport — see each sport page for details.</em></p>
                            <h3>Highlights</h3>
                            <ul>
                                <li>Choose one focus area each week—strength, speed, mental toughness, and more</li>
                                <li>Daily training to develop your selected specialization</li>
                                <li>IMG Academy 1-on-1 Coaching with customized feedback and drills</li>
                                <li>Target specific skills to sharpen your game</li>
                            </ul>
                            <div class="videoWrapper">
                                <div class="videoContainer">
                                    <h4>Performance Training</h4>
                                    <div class="embed-responsive embed-responsive-16by9 dynamic">
                                        <iframe class="embed-responsive-item" width="560" height="315" src="https://player.vimeo.com/video/1008949944" title="The Bedford Family" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                        <img src="" class="embed-responsive-item hide-all">
                                    </div>
                                    <div class="ctas">
                                        <div class="selectHolder">
                                        <select class="btn22 hrefselect">
                                            <option value="Strength & Power">Strength & Power</option>
                                            <option value="Speed & Agility">Speed & Agility</option>
                                            <option value="Leadership & Communication">Leadership & Communication</option>
                                            <option value="Mental Performance">Mental Performance</option>
                                            <option value="Recovery+">Recovery+</option>
                                            <option value="Build Your Brand">Build Your Brand</option>
                                            <option value="Athlete Assessment & Injury Prevention">Athlete Assessment & Injury Prevention</option>
                                            <option value="English as a Second Language">English as a Second Language</option>
                                        </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="videoContainer">
                                    <h4>Personalized Coaching</h4>
                                    <div class="embed-responsive embed-responsive-16by9 static">
                                      <iframe class="embed-responsive-item" width="560" height="315" src="https://player.vimeo.com/video/1113979468" title="The Bedford Family" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                      <img src="https://www.imgacademy.com/sites/default/files/build-your-brand-specialization.jpg" class="embed-responsive-item hide-all">
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>`;
           var overlayOptions = {
               btnOpen: null,
               callbackOpen: onGameChangerModal,
               containerClassOverride: 'fullscreen-overlay camp-popups twentySixSCPgeneral learnMorePopup',
               overlayType: 'popup',
               type: 'html',
               content: tempContent
           };
           var overlay = new ContentOverlay2(overlayOptions);
           overlay.open();
           break;
       // BT popup
       case "Breakthrough Training Upgrade":
       var tempContent = `<div class="personalizedCoachingModal">
                           <h2>Personalized Coaching Sessions</h2>
                           <p class="subhead">*Subject to availability when booking</p>

                           <div class="descriptionHolder">
                               <div class="contentHolder">
                               <h3>For Ages 11 - 18*</h3>
                               <p>Take your game to the next level with personalized training added to your camp experience.</p>
                               <p><em>*Age eligibility differs by sport — see each sport page for details.</em></p>
                               <h3>Highlights</h3>
                               <ul>
                                   <li>Four extra sessions each week, tailored to your goals</li>
                                   <li>Small-group coaching for targeted attention</li>
                                   <li>Improve skills, strategy, mechanics, or fundamentals</li>
                                   <li>Gain focused development, measurable progress, and confidence</li>
                               </ul>
                               <div class="embed-responsive embed-responsive-16by9">
                                   <iframe class="embed-responsive-item" width="560" height="315" src="https://player.vimeo.com/video/1113979468" title="The Bedford Family" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                               </div>
                               </div>
                           </div>
                           </div>`;

         var overlayOptions = {
             btnOpen: null,
             containerClassOverride: 'fullscreen-overlay camp-popups twentySixSCPgeneral learnMorePopup',
             overlayType: 'popup',
             type: 'html',
             content: tempContent
         };
         var overlay = new ContentOverlay2(overlayOptions);
         overlay.open();
         break;
        default:
            break;
    }
}

function onGameChangerModal() {
    // Video URLs for each specialization
    const specializationVideos = {
        'Strength & Power': 'https://player.vimeo.com/video/1008181416?h=4570e5b34e&amp;origin=https:%2F%2Fwww.imgacademy.com',
        'Speed & Agility': 'https://player.vimeo.com/video/1008182784?h=66f2799a50&amp;origin=https:%2F%2Fwww.imgacademy.com',
        'Leadership & Communication': 'https://player.vimeo.com/video/1008180788?h=b151b50f43&amp;origin=https:%2F%2Fwww.imgacademy.com',
        'Mental Performance': 'https://player.vimeo.com/video/1008184316?h=b56c53fc68&amp;origin=https:%2F%2Fwww.imgacademy.com',
        'Recovery+': 'https://player.vimeo.com/video/1008181818?h=6989e5cde3&amp;origin=https:%2F%2Fwww.imgacademy.com',
        'Build Your Brand': 'https://www.imgacademy.com/sites/default/files/build-your-brand-specialization.jpg',
        'Athlete Assessment & Injury Prevention': 'https://player.vimeo.com/video/1008184938?h=d0cea89cc6&amp;origin=https:%2F%2Fwww.imgacademy.com',
        'English as a Second Language': 'https://player.vimeo.com/video/1008182390?h=40825ae7c5&amp;origin=https:%2F%2Fwww.imgacademy.com'
    };

    // Function to change video
    function changeVideo(selectedSpecialization) {
        var dynamicIframe = document.querySelector('.dynamic iframe');
        var dynamicImg = document.querySelector('.dynamic img');
        var newUrl = specializationVideos[selectedSpecialization];

        if (newUrl && selectedSpecialization === 'Build Your Brand') {
            if (dynamicImg) dynamicImg.src = newUrl;
            if (dynamicIframe) dynamicIframe.classList.add('hide-all');
            if (dynamicImg) dynamicImg.classList.remove('hide-all');
        } else if (newUrl) {
            if (dynamicIframe) dynamicIframe.src = newUrl;
            if (dynamicIframe) dynamicIframe.classList.remove('hide-all');
            if (dynamicImg) dynamicImg.classList.add('hide-all');
        }
    }

    const dropdown = document.querySelector('.btn22.hrefselect');

    if (dropdown) {
        // Set initial video (Strength & Power by default)
        changeVideo('Strength & Power');

        // Listen for dropdown changes
        dropdown.addEventListener('change', function() {
            const selectedSpecialization = this.options[this.selectedIndex].text;
            changeVideo(selectedSpecialization);
        });
    }
}
